import { useEffect } from 'react';
import { analyticsClient } from './client';

export default function AnalyticsErrorBoundary({ children }) {
  useEffect(() => {
    const report = (type, message) => {
      analyticsClient.track('client_error', {
        path: window.location.pathname,
        product: /ielts/i.test(window.location.pathname) ? 'ielts' : 'general',
        properties: {
          error_type: type,
          message: String(message || 'Unknown client error').slice(0, 300),
        },
      });
    };
    const onError = (event) => report('window_error', event.message);
    const onRejection = (event) => report('unhandled_rejection', event.reason?.message || event.reason);
    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onRejection);
    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onRejection);
    };
  }, []);

  return children;
}
